import { ZERO_POINT } from "#constants"
import type { Distance, Point, Rectangle, SpatialRectangle } from "#public"

// Place a `Rectangle` (width/height) at an origin. Only the origin's x/y are
// taken — width/height always come from `rect`, even when `origin` happens to
// carry its own (e.g. a full SpatialRectangle passed as the anchor).
export const ToSpatial = (
  { width, height }: Rectangle<Distance>,
  { x, y }: Point<Distance> = ZERO_POINT
): SpatialRectangle<Distance> => ({
  x,
  y,
  width,
  height,
})
